import { c as _c } from "react/compiler-runtime";
import type { SentilinkDetail } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import Score from './components/score';
type SentilinkContentProps = {
  data?: SentilinkDetail;
};
const SentilinkContent = t0 => {
  const $ = _c(11);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "classicOnboardings.riskSignals.drawer.sentilink"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  if (!data) {
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="text-body-2">Loading...</div>;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    return t2;
  }
  const {
    idTheft,
    synthetic
  } = data;
  let t2;
  if ($[2] !== synthetic || $[3] !== t) {
    t2 = synthetic && <Score score={synthetic.score} scoreBand={synthetic.scoreBand} reasonCodes={synthetic.reasonCodes} title={t(_temp)} />;
    $[2] = synthetic;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== idTheft || $[6] !== t) {
    t3 = idTheft && <Score score={idTheft.score} scoreBand={idTheft.scoreBand} reasonCodes={idTheft.reasonCodes} title={t(_temp2)} />;
    $[5] = idTheft;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="flex flex-col gap-5">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export default SentilinkContent;
function _temp($) {
  return $.score.syntheticTitle;
}
function _temp2($_0) {
  return $_0.score.idTheftTitle;
}